import {Modal} from "@ui";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {ErrorBoundary, useErrorBoundary} from "react-error-boundary";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {PrimaryButton} from "@/components/Button";
import {useLogo} from "../../../util/logoUtils";
import styles from "../ErrorBoundaryHandler.module.css";

const FallbackComponentRedirect = () => {
  const {resetBoundary} = useErrorBoundary();
  const [resetCalled, setResetCalled] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const {t} = useTranslation();
  const logoImg = useLogo(); // Dynamic logo based on hostname

  const handleErrorState = () => {
    window.location.href = "/";
    resetBoundary();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
      if (!resetCalled) {
        resetBoundary();
        setResetCalled(true);
      }
    }, 5000); // Redirect after 5 seconds

    const countdownTimer = setInterval(() => {
      setCountdown(c => (c > 0 ? c - 1 : 0));
    }, 1000);

    return () => {
      clearTimeout(timer);
      clearInterval(countdownTimer);
    };
  }, [navigate, resetBoundary, resetCalled]);

  return (
    <Modal
      open={true}
      footer={null}
      closable={false}
      centered
      width={555}
      styles={{
        body: {
          padding: window.innerWidth <= 768 ? "32px 0px 24px 0px" : "32px 32px 24px 32px",
          borderRadius: 16,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      <div className={styles.error_boundary_container}>
        <img
          src={logoImg}
          alt="Logo"
          className={styles.errorBoundaryLogoImg}
        />
        <p className={styles.error_boundary_title}>{t("errorBoundaryRedirect1")}</p>
        <p
          className={styles.error_boundary_action}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
        >
          <span style={{fontSize: 16, textAlign: "center"}}>
            {t("errorBoundaryRedirect2")} <span style={{fontWeight: 600}}>({countdown})</span>
          </span>
        </p>
        <PrimaryButton
          onClick={handleErrorState}
          style={{marginTop: 30}}
        >
          {t("errorBoundaryBtnHome")}
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export const ErrorBoundaryRedirect = ({children}) => {
  return <ErrorBoundary FallbackComponent={FallbackComponentRedirect}>{children}</ErrorBoundary>;
};

ErrorBoundaryRedirect.propTypes = {
  children: PropTypes.node,
};
